export default __webpack_public_path__ + "static/media/day_out_with DSC.2be0885c.jpeg";